<script lang="ts">
  import { onMount } from 'svelte'
  import { cubicOut } from 'svelte/easing'
  import { Tween } from 'svelte/motion'

  interface Props {
    dollarSign: boolean
    value?: number
    duration?: number
  }

  let { dollarSign, value = 0, duration = 3000 }: Props = $props()

  const displayValue = new Tween(0, {
    easing: cubicOut,
  })

  let mounted = $state(false)
  let reduceMotion = $state(false)

  onMount(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    const syncPreference = () => (reduceMotion = mediaQuery.matches)
    syncPreference()
    mounted = true
    mediaQuery.addEventListener('change', syncPreference)
    return () => mediaQuery.removeEventListener('change', syncPreference)
  })

  $effect(() => {
    if (mounted) void displayValue.set(value, { duration: reduceMotion ? 0 : duration })
  })

  function formatNumber(num: number) {
    if (num >= 1000) {
      return (
        (dollarSign ? '$' : '') +
        new Intl.NumberFormat('en', {
          notation: 'compact',
          compactDisplay: 'short',
          maximumFractionDigits: 1,
        }).format(num)
      )
    }
    const formattedNum = Number(num.toFixed(1))
    return dollarSign ? '$' + formattedNum : formattedNum
  }
</script>

<span>{formatNumber(displayValue.current)}</span>
